(function() {
  
  angular
	.module('meanApp')
	.controller('profileCtrl', profileCtrl);

  profileCtrl.$inject = [
  '$scope',
  '$location',
  '$state',
  '$rootScope',
  'usersManager',
  'recipesManager',
  'alert',
  '$uibModal',
  '$window', 
  'context',
  'currentUser'];
  function profileCtrl(
  	$scope, 
  	$location, 
  	$state, 
  	$rootScope, 
  	usersManager, 
  	recipesManager, 
  	alert, 
  	$uibModal, 
  	$window, 
    context,
    currentUser) {


	console.log('in the profile controller');
	console.log('state params are ', $state);
    var vm = this;
    $scope.$state = $state;
    $scope.editionMode = false;

	usersManager.get($state.params.id).then(function(result) {
        $scope.user = result;
        console.log('$rootscope is', $rootScope);

        currentUser.get().then(function(currentUserModel) {
            if($scope.user._id === currentUserModel._id) {
                //only add more if current user
                context.set({
                    //iconAction : 'more',
                    //for each actions an icon and a title and an action callback
                    dropDownActions : [{
                        iconName : 'user',
                        actionTitle : 'Profil',
                        dropdownActionCallback : function() {
                            //reset the name of the context
                            $state.go('profile.info');
                            context.set({
                                contextName : currentUserModel.name
                            });
                        }
                    },{
                        iconName : 'cook',
                        actionTitle : 'Mes recettes',
                        dropdownActionCallback : function() {
                            //reset the name of the context
                            $state.go('profile.recipes');
                            context.set({
                                contextName : 'Mes Recettes'
                            });
                        }
                    },{
                        iconName : 'bookmark',
                        actionTitle : 'Sauvegardes',
                        dropdownActionCallback : function() {
                            //reset the name of the context
                            $state.go('profile.bookmarks');
                            context.set({
                                contextName : 'Recettes sauvegardées'
                            });
                        }
                    },{
                        iconName : 'heart',
                        actionTitle : 'Recettes aimées',
                        dropdownActionCallback : function() {
                            //reset the name of the context
                            $state.go('profile.likes');
                            context.set({
                                contextName : 'Recettes aimées'
                            });
                        }
                    },{
                        iconName : 'cog',
                        actionTitle : 'Paramètres',
                        dropdownActionCallback : function() {
                            //reset the name of the context
                            $state.go('profile.settings');
                            context.set({
                                contextName : 'Paramètres'
                            });
                        }
                    }]
                });
            }
        });
		context.set({
			contextName : result.name
		});
	});

	context.set({
		iconAction : null//, //only if current user
		//iconCallback : vm.onClickHeartNavbar,
		//colorBackground : '#fe5f55'
	});

	//default size or editor
	$scope.pixelSideEditor = {
	  'width': '100px',
	  'height' : '100px'
	};
	$scope.imageSource = '';//"data:image/gif;base64,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";
	$scope.myCroppedImage = '';
	$scope.resultImageSize= 150;

	var dataURLtoFile = function (dataurl, filename) {
	  var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
		  bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
	  while(n--){
		  u8arr[n] = bstr.charCodeAt(n);
	  }
	  return new File([u8arr], filename, {type:mime});
	}

	var setOptimizedWidthAndHeight = function(width, height) {
		//compute a square but not larger than 400px max
		var minSide = Math.min(width, height),
		minSideIsWidth = minSide === width,
		effectiveSide = 100, effectiveHeight, effectiveWidth;

		if (minSide > 400) {
			effectiveSide = 400;
		}
		else if (minSide > 100){
			effectiveSide = minSide;
		}

		if(!minSideIsWidth) {
			effectiveWidth = effectiveSide; // retrieve the 20 px of margin
			effectiveHeight = parseInt(effectiveWidth * height / width, 10);
		}
		else {
			effectiveHeight = effectiveSide;
			effectiveWidth = parseInt(width * effectiveHeight / height, 10);
        }
        
        var widthAvailable = window.document.getElementsByClassName('website-container')[0].offsetWidth - 20; //remove the margins
        
        //regulate the width
    	if(widthAvailable < effectiveWidth) {
            effectiveWidth = widthAvailable;
            effectiveHeight = parseInt(height*effectiveWidth/width);
        }
        
        $scope.pixelSideEditor = {
			'width': effectiveWidth + 'px',
			'height' : effectiveHeight + 'px'
        };
	};

	$scope.onFileChange = function (imageSource, width, height) {
	  //1-first convert it into an image source
	  //http://stackoverflow.com/questions/38505673/converting-file-object-to-image-object-in-javascipt
	  //DONE in controller
	  $scope.imageSource = imageSource;
	  console.log('image width is ' + width);
	  console.log('image height is ' + height);

	  setOptimizedWidthAndHeight(width, height);

  		//here open a modal in order to edit the picture
   		$scope.modal = $uibModal.open({
      		templateUrl: 'profile/change.picture.modal.view.html',
            scope : $scope,
            backdrop: 'static'
    	});

    $scope.modal.rendered.then(function() {
    	console.log('modal change picture is rendered');
    	//this.document.body.get modal-content
    	var widthAvailable = window.document.getElementsByClassName('modal-content')[0].offsetWidth - 20; //remove the margins
    	//what if prortrait image ?
    	if(widthAvailable < width) {
    		
    		$scope.pixelSideEditor = {
				'width': widthAvailable + 'px',
				'height' : parseInt(height*widthAvailable/width) + 'px'
            };
            
            //$scope.$apply();
    	}
    });

	  /**$http.post(uploadUrl, fd, {
		  withCredentials: true,
		  headers: {'Content-Type': undefined },
		  transformRequest: angular.identity
	  }).success( console.log('...all right!...').error(console.log('..damn!...');**/
	  //console.log(files[0]);
	  //2 create an image instance in js
	  //canvas pas mal https://tympanus.net/codrops/2014/10/30/resizing-cropping-images-canvas/
	  //https://github.com/alexk111/ngImgCrop vraiment pas mal avec directive pour angular :)

	  //3 use jic module to compress it and serve it to the server
	  //https://github.com/brunobar79/J-I-C/blob/master/src/JIC.js
	};

	vm.displayChangePasswordView = false;

	vm.onChangePassword = function () {
		vm.displayChangePasswordView = true;
	};

	vm.removePasswordChanges = function() {
		vm.oldPassword = '';
		vm.newPassword = '';
		vm.newSecondPassword = '';
		vm.displayChangePasswordView = false;
	};

	$scope.saveProfilePicture = function () {
		//console.log($scope.imageSource);
		console.log('needs to save profile pic through api - not defined yet.');

		var fileBuiltFromeBase64 = dataURLtoFile(this.myCroppedImage, 'avatar'),
		fd = new FormData();
		fd.append('file', fileBuiltFromeBase64);//pass the file newly created

		console.log('the filename is', fileBuiltFromeBase64.filename);
		//put the button in loading mode
		this.user.uploadProfilePicture(fd).then(function() {
				//close the modal
				this.modal.close();
				alert.push('success', 'Votre photo de profil a été mise à jour');
				//init the image to undefined so the view changes accordingly
				this.imageSource = '';
				this.myCroppedImage = '';
			}.bind(this), function() {
				alert.push('danger', "Votre photo n'a pu être uploadée, veuillez réessayer ultérieurement");
		});//call ofthe upload function that is on the user-model.js
	};

	vm.updateUserInformation = function() {
		console.log('all the information to update', $scope.user);
		var data = {
		  'biography': $scope.user.biography,
		  'weight': $scope.user.weight ? $scope.user.weight : 0,
		  'size': $scope.user.size ? $scope.user.size : 0,
          'website': $scope.user.website,
          'name' : $scope.user.name
		};
		console.log('update user information');

		$scope.user.update(data).then(function() {
			alert.push('success', 'Votre profil a été mis à jour');
			$scope.editionMode = false;
		}, function() {
			alert.push('danger', "Votre profil n'a pas été mis à jour, veuillez réessayer ultérieurement");
			$scope.editionMode = true;
		});
	};

	vm.updatePassword = function() {
		if (vm.newSecondPassword === vm.newPassword) {
			var data = {
				oldPassword : vm.oldPassword,
				newPassword : vm.newPassword,
				email : $scope.user.email
			};
			$scope.user.changePassword(data).then(function() {
				alert.push('success', 'Votre mot de passe a été changé');
				vm.removePasswordChanges();
			}, function(error) {
				console.log(error);
				alert.push('danger', "Votre ancien mot de passe est faux");
			});
		}
		else {
			vm.passwordsNotEqual = true;
			alert.push('danger', "Veuillez vérifier votre nouveau mot de passe");
		}
	};

	vm.getAllRecipesFromUser = function() {
        console.log('get all recipes from user is asked');
        //just the first page for now
		return recipesManager.getAllRecipesFromUser($state.params.id, 1)
	  	.then(function(recipes) {
	  		console.log('results of recipes of a given user', recipes);
	  		return recipes;
	  	}, function(err) {
			console.log('erreur loading all profiles');
			console.log(err);
	  	});
    };
    
    vm.loadMoreRecipes = function() {
        console.log('load more ...');
    };  

	vm.onEyeClicked = function () {
		vm.showPassword = !vm.showPassword;
	};

	vm.switchToEdit = function () {
		$scope.editionMode = true;
		$state.go('profile.info');
	};
	vm.switchToRead = function () {
		$scope.editionMode = false;
	};
	
	vm.logout = function() {
		//TODO User is not defined here
		$rootScope.currentUser.logout(function() {
    		$rootScope.isLoggedIn = false;
    		alert.push('success', 'Vous êtes déconnecté');
    	});
  	};
  }

})();